import { AccountingLedgerBasis } from "./ledger";

export enum ConsolidationEntityRelationshipType {
    ownership = "ownership",
    loan = "loan",
    rent = "rent",
    cashSweep = "cash_sweep",
    managementFee = "management_fee",
    sharedExpenses = "shared_expenses",
    other = "other",
}

export interface ConsolidationRelationshipMetadata {
    name?: string;
    ownershipType?: string;
    payment?: string;
    targetBalance?: string;
    frequency?: string;
    roleLabel?: string;
    notes?: string;
}

export interface ConsolidationGroupEntityRelationship {
    id: string;
    workspaceId: string;
    type: ConsolidationEntityRelationshipType;
    sourceEntityUuid: string;
    targetEntityUuid: string;
    ownershipPercentage: number | null;
    startDate: string | null;
    endDate: string | null;
    metadata: ConsolidationRelationshipMetadata | null;
}

export enum ConsolidationGroupStatus {
    draft = "draft",
    active = "active",
    archived = "archived",
}

export enum ConsolidationTreatment {
    consolidates = "consolidates",
    doesNotConsolidate = "does_not_consolidate",
}

export interface ConsolidationGroupConfig {
    basis?: AccountingLedgerBasis;
    ledgerIdsByEntityUuid?: Record<string, string>;
    periodConvention?: string;
}

export interface ConsolidationGroup {
    id: string;
    workspaceId: string;
    name: string;
    parentEntityUuid: string;
    status: ConsolidationGroupStatus;
    overlayLedgerId: string | null;
    config: ConsolidationGroupConfig | null;
}

export interface ConsolidationGroupMember {
    id: string;
    groupId: string;
    workspaceId: string;
    entityUuid: string;
    consolidationTreatment: ConsolidationTreatment;
    joinedAt: string | null;
}

export interface CanvasNodePosition {
    x: number;
    y: number;
}

/** Hand-placed node coordinates keyed by canvas node id (entity uuid or `group:<id>`). */
export type CanvasLayoutPositions = Record<string, CanvasNodePosition>;

export interface ConsolidationCanvasLayout {
    id: string;
    workspaceId: string;
    positions: CanvasLayoutPositions;
}
